import React from 'react'
import { compose } from 'recompose'
import classnames from 'classnames'
import { connect } from 'react-redux'
import Dropzone from 'react-dropzone'
import { Icon } from 'semantic-ui-react'
import { toastError, toastWarning, showConfirmModal } from 'ducks/app'
import styled from '@emotion/styled'
import * as v from 'variables/styled'
import FileUploadCell from 'components/FileUploadCell'

export const DropzoneContainer = styled.div({
  display: 'flex',

  '.inputContent': {
    display: 'flex',
    flex: 1,
    width: '100%',
  },

  '.dropArea': {
    cursor: 'pointer',
    display: 'flex',
    background: '#FFF',
    border: `dashed 1.5px ${v.borderGray}`,
    borderRadius: '5px',
    padding: '5px 0px',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    flex: 1,
    width: '100%',

    '.textTitle': {
      fontSize: '1.25rem',
      color: '#505050',

      svg: {
        fontSize: '1rem',

        path: {
          color: v.btnGray,
        },
      },
    },

    '.buttonUI': {
      height: '35px',
      background: v.bgSoftGray, 
      borderRadius: '5px', 
      fontSize: '1.25rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: '200px',
      color: '#505050',
    },
  },

  '.dropArea.error': {
    backgroundColor: '#fff6f6',
    borderColor: '#e0b4b4',
  },

  '@media only screen and (min-width: 600px)': {
    '.dropArea': {
      flexDirection: 'row-reverse',
    }
  },

  '@media only screen and (min-width: 769px)': {
    '.dropArea': {
      flexDirection: 'row-reverse',
    }
  },
})

const FileInput = (props) => {
  const { label, oldFiles, change, input, duplicateCheck, style, meta: { touched, error } } = props
  return (
    <div className='fieldRow' style={{...style}}>
      <span className='fieldLabel' style={{ color: '#888888' }}>
        {label} <span style={{color:'red', fontSize:'1.3rem', fontWeight:'bold'}}>{` ${error||''}`}</span>
      </span>
      <div className='fieldInput'>
        <Dropzone
          name={input.fileName}
          accept='.xlsx,.xls,image/*,.doc,.docx,.ppt,.pptx,.txt,.pdf,.zip,.rar,.msg'
          onDrop={
          acceptedFiles => {
            acceptedFiles.forEach(file => {
              const reader = new FileReader()
              reader.onload = () => {
                if (input.value === '' || input.value === undefined) {
                  if(duplicateCheck){
                    let oldFileDup = oldFiles?oldFiles.filter(x=>(x.originalFilename===file.path)&&(!x.deleted)):-1
                    if(!oldFileDup.length){
                      input.onChange([file])
                    }else{
                      props.showConfirmModal(
                        true,
                        {
                          header: 'Systems',
                          message: 'There is already a file with the same name, Would you like to replace the existing file?',
                          btnConfirmText: 'Yes',
                          btnCancelText: 'No',
                          onClickConfirm: () => {
                            let attachClone = JSON.parse(JSON.stringify(oldFiles))
                            attachClone.forEach((item,i)=>{
                              attachClone[i].createdDate = oldFiles[i].createdDate
                              attachClone[i].modifiedDate = oldFiles[i].modifiedDate
                              attachClone[i].urlExpireDate = oldFiles[i].urlExpireDate
                              if(oldFileDup.findIndex(x=>x.id===item.id)>=0){
                                attachClone[i].deleted = true
                              }
                            })
                            change(`attachments`,attachClone)
                            input.onChange([file])
                          }
                        }
                      )
                    }
                  } else {
                    input.onChange([file])
                  }
                } else {
                  if(duplicateCheck){
                    let newFileDup = input.value.findIndex(x=>x.path===file.path)
                    let oldFileDup = oldFiles?oldFiles.findIndex(x=>x.originalFilename===file.path&&!x.deleted):-1
                    if(oldFileDup<0&&newFileDup<0){
                      input.onChange([...input.value, file])
                    }else{
                      props.showConfirmModal(
                        true,
                        {
                          header: 'Systems',
                          message: 'There is already a file with the same name, Would you like to replace the existing file?',
                          btnConfirmText: 'Yes',
                          btnCancelText: 'No',
                          onClickConfirm: () => {
                            if(newFileDup>=0){
                              input.value.splice(newFileDup,1)
                              input.onChange([...input.value, file])
                            }else{
                              input.onChange([...input.value, file])
                              change(`attachments[${oldFileDup}].deleted`,true)
                            }
                          }
                        }
                      )
                    }
                  }else{
                    input.onChange([...input.value, file])
                  }
                }
              }
              reader.onabort = () => toastError('file reading was aborted')
              reader.onerror = () => toastError('file reading has failed')

              reader.readAsBinaryString(file)
            })
          }}
        >
          {({ getRootProps, getInputProps, isDragActive }) => {
            return (
              <DropzoneContainer
                {...getRootProps()}
                className={classnames('dropzone', { 'dropzone--isActive': isDragActive })}
              >
                <div className='inputContent'>
                  <input {...getInputProps()} />
                  <div className={classnames('dropArea', { error: touched && error })}>
                    <div className='textTitle'><Icon name='upload' /> Drag file to upload</div>
                    <div className='textTitle' style={{ margin: '0px 10px' }}>Or</div>
                    <div className='buttonUI'>Choose File</div>
                  </div>
                </div>
              </DropzoneContainer>
            )
          }}
        </Dropzone>
        {
          input.value && input.value instanceof Array ? 
            input.value.map((file, index) => {
              return(
                <FileUploadCell
                  key={file.name}
                  fileName={file.name}
                  fileSize={file.size}
                  style={{ marginTop: '5px' }}
                  onClickDelete={() => {
                    var clone = [...input.value]
                    clone.splice(index, 1)
                    input.onChange([...clone])
                  }} />
              )
            }) : null
        }
      </div>
    </div>
  )
}
const mapStateToProps = (state) => {}
const mapDispatchToProps = {
  toastWarning,
  showConfirmModal
}
const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps)
)

export default enhance(FileInput)